import { render, staticRenderFns } from "./Dossiers.vue?vue&type=template&id=0b58b752&"
import script from "./Dossiers.vue?vue&type=script&lang=js&"
export * from "./Dossiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports